import { render } from "./AddCategoryModal.vue?vue&type=template&id=08e4bf06&ts=true"
import script from "./AddCategoryModal.vue?vue&type=script&lang=ts"
export * from "./AddCategoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__